import { Component, inject, Inject } from '@angular/core';
import { ModalLayoutComponent } from '../modal-layout/modal-layout.component';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';

import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatFormField } from '@angular/material/select';
import { MatInput } from '@angular/material/input';
import { AnnouncementService } from '../../../services/announcement.service';
import { MatLabel } from '@angular/material/form-field';
import { PageService } from '../../../services/page.service';
import { PageModel } from '../../../models/page.models';

@Component({
  selector: 'app-modal-feedback',
  imports: [
    ModalLayoutComponent,
    ReactiveFormsModule,
    MatFormField,
    MatInput,
    MatLabel,
    MatFormField,
    ReactiveFormsModule,
  ],
  templateUrl: './modal-feedback.component.html',
  standalone: true,
  styleUrl: './modal-feedback.component.scss',
})
export class ModalFeedbackComponent {
  page: PageModel | null = null;
  pageService = inject(PageService);
  feedbackForm: FormGroup;
  selectedFile: File | null = null;
  private dialogRef = inject(MatDialogRef<ModalFeedbackComponent>);
  private announcementService = inject(AnnouncementService);
  fileTouched = false;

  constructor(
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: { announcementId: string },
  ) {
    this.feedbackForm = this.fb.group({
      organisation: ['', Validators.required],
      fullName: ['', Validators.required],
      description: ['', Validators.required],
      announcementId: [data.announcementId, Validators.required],
    });
    this.pageService.getPage('announcements').subscribe((page) => {
      this.page = page;
    });
  }

  onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input?.files?.length) {
      this.selectedFile = input.files[0];
    }
  }

  onSubmit() {
    this.fileTouched = true;
    if (this.feedbackForm.valid) {
      const formData = new FormData();
      formData.append('organisation', this.feedbackForm.value.organisation);
      formData.append('fullName', this.feedbackForm.value.fullName);
      formData.append('description', this.feedbackForm.value.description);
      formData.append('announcementId', this.feedbackForm.value.announcementId);
      if (this.selectedFile) {
        formData.append('file', this.selectedFile);
      }
      this.announcementService.createSupport(formData).subscribe(
        (res) => {
          this.dialogRef.close(true);
        },
        (err) => {
          console.error(err);
        },
      );
    }
  }
}
